<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
    <path
      d="M1.75 13.8333L13.7812 1V9.16667H21L8.96875 22V13.8333H1.75Z"
      stroke="currentColor"
      stroke-opacity="0.94"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
